import { useNavigate } from "react-router-dom";
import { toAbsoluteUrl } from "../../../_metronic/helpers";
//import { goToLink, HistoryCard } from "../projectData";
//import WelcomePopup from "./popup";
//import { useEffect, useState } from "react";
//import { getUserDashboard } from "../api";
import { useRouteData } from "../RouteDataContext";
/**
 * CortevaGalileoDashboard component displays a custom dashboard for Corteva Galileo users, including navigation to KYC, Purchase, Cashback, and Support.
 */
const CortevaGalileoDashboard = ({ projectData }) => {
    const navigate = useNavigate();
    const { userData } = useRouteData();
    // const [dashboard, setDashboard] = useState(null);

    // useEffect(() => {
    //     if (userData && projectData) {
    //         getUserDashboard({ id: userData?.user?.iirpl_sap_code, project_key: projectData?.pkey }).then((d) => setDashboard(d?.data))
    //     }
    // }, [userData, projectData])

    return (
        <div className="container py-0 px-0">
            <div className=" bg-white p-6  py-2">
                <div className="text-center">
                    <div className="fw-semibolder fs-4 fw-semibolder">Welcome: <span className="mb-4 ms-2 text-capitalize  me-2 " style={{ color: "#2D4D9E" }}>{userData?.user?.first_name} {userData?.user?.last_name}</span></div>
                    <div className="text-capitalize fs-6 fw-semibold">{userData?.user?.firm_name ? userData?.user?.firm_name : '--'}  </div>
                </div>

                <div className="mt-3"><div className="d-none mt-3 d-md-block">
                    <img
                        src={projectData?.banner ? toAbsoluteUrl(projectData?.banner) : ''}
                        alt="Banner"
                        className="w-lg-100  img-fluid "
                    />
                </div>
                    <div className="d-block d-md-none">
                        <img
                            src={projectData?.banner ? toAbsoluteUrl(projectData?.banner) : ''}
                            alt="Banner"

                            className="img-fluid rounded  w-100"
                        />
                    </div>
                </div>

            </div>

            <div className='container bg-gray-200 vh-100 pt-4 mb-10'>
                <div className="d-flex gap-3 flex-column">
                    <div className='d-flex justify-content-between flex-wrap'>
                        <div className='card shadow-sm min-h-80px w-100 cursor-pointer' style={{ backgroundColor: "#fff", border: "1px solid #fff" }}
                            onClick={() => navigate(`/customer/bankpancard-details/${userData?.user?.iirpl_sap_code}`)}
                        >
                            <div className='card-body p-5 py-2 d-flex justify-content-between align-items-center'>
                                <div className='text-start d-flex align-items-center'>
                                    <img style={{ width: '32px' }} className="me-4" src={toAbsoluteUrl('/media/images/kyc@2x.png')} alt="kyc" />
                                    <div className='d-flex flex-column'>
                                        <div className='fw-semibold  text-dark '>KYC</div>
                                        <div className=' fw-semibold w-100' style={{ color: "#717171" }}>Click here to upload your Pan, Bank details</div>
                                    </div>
                                </div>
                                <div className="d-inline-flex align-items-center justify-content-center  rounded-circle" style={{ width: '20px', height: '20px', backgroundColor: "#597445" }}>
                                    <i className="fas fa-chevron-right   text-white"></i>
                                </div>

                            </div>


                        </div>
                    </div>

                    <div className='d-flex justify-content-between flex-wrap'>
                        <div className='card shadow-sm min-h-80px w-100 cursor-pointer' style={{ backgroundColor: "#fff", border: "1px solid #fff" }}
                            onClick={() => navigate(`/customer/purchase/${userData?.user?.iirpl_sap_code}`)}
                        >
                            <div className='card-body p-5 py-2 d-flex justify-content-between align-items-center'>
                                <div className='text-start d-flex align-items-center'>
                                    <img style={{ width: '32px' }} className="me-4" src={toAbsoluteUrl('/media/images/shopping-cart@2x.png')} alt="cart" />
                                    <div className='d-flex flex-column'>
                                        <div className='fw-semibold  text-dark '>Purchase</div>
                                        <div className=' fw-semibold w-100' style={{ color: "#717171" }}>Click here to track your Purchase</div>
                                    </div>
                                </div>
                                <div className="d-inline-flex align-items-center justify-content-center  rounded-circle" style={{ width: '20px', height: '20px', backgroundColor: "#597445" }}>
                                    <i className="fas fa-chevron-right   text-white"></i>
                                </div>
                            </div>
                        </div>
                    </div>


                    <div className='d-flex justify-content-between flex-wrap'>
                        <div className='card shadow-sm min-h-80px w-100 cursor-pointer' style={{ backgroundColor: "#fff", border: "1px solid #fff" }}
                            onClick={() => navigate(`/customer/cashback/${userData?.user?.iirpl_sap_code}`)}
                        >
                            <div className='card-body p-5 py-2 d-flex justify-content-between  align-items-center'>
                                <div className='text-start d-flex align-items-center'>
                                    <img style={{ width: '32px' }} className="me-4" src={toAbsoluteUrl('/media/images/customer-service(1)@2x.png')} alt="customer" />
                                    <div className='d-flex flex-column'>
                                        <div className='fw-semibold  text-dark '>Cashback</div>
                                        <div className=' fw-semibold w-100' style={{ color: "#717171" }}>Click here to track your cashback</div>
                                    </div>
                                </div>
                                <div className="d-inline-flex align-items-center justify-content-center  rounded-circle" style={{ width: '20px', height: '20px', backgroundColor: "#597445" }}>
                                    <i className="fas fa-chevron-right   text-white"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='d-flex justify-content-between flex-wrap'>
                        <div className='card shadow-sm min-h-80px w-100' style={{ backgroundColor: "#fff", border: "1px solid #fff" }}
                            onClick={() => navigate(`/customer/support/${userData?.user?.iirpl_sap_code}`)}
                        >
                            <div className='card-body p-5 py-2 d-flex justify-content-between align-items-center'>
                                <div className='text-start d-flex align-items-center'>
                                    <img style={{ width: '32px' }} className="me-4" src={toAbsoluteUrl('/media/images/return@2x.png')} alt="corteva" />
                                    <div className='d-flex flex-column'>
                                        <div className='fw-semibold  text-dark '>Support</div>
                                        <div className=' fw-semibold w-100' style={{ color: "#717171" }}>Click here to reach out to our support team</div>
                                    </div>
                                </div>
                                <div className="d-inline-flex align-items-center justify-content-center  rounded-circle" style={{ width: '20px', height: '20px', backgroundColor: "#597445" }}>
                                    <i className="fas fa-chevron-right   text-white"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>

        </div >
    )

}

export default CortevaGalileoDashboard